/*
 |-----------------------------------------------------------
 | EM Theme v1 Scripts
 |-----------------------------------------------------------
 |
 |
 |
 |-----------------------------------------------------------
 */
$(document).ready(function() {
    'use strict';

    $('.dropdown > a').dropdown();

    // /* ==== 1) Fix for Internet Explorer 10 in Windows 8 and Windows Phone 8 ==== */
    // if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    //     var msViewportStyle = document.createElement("style");
    //     msViewportStyle.appendChild(
    //         document.createTextNode(
    //             "@-ms-viewport{width:auto!important}"
    //         )
    //     );
    //     document.getElementsByTagName("head")[0].appendChild(msViewportStyle)
    // }

    // Init global DOM elements, functions and arrays
    // window.app               = {el : {}, fn : {}};
    // app.el['window']         = $(window);
    // app.el['document']       = $(document);

    // Animated Appear Element
    // if (app.el['window'].width() > 1024) {
    //     if ($.fn.appear) {
    //         // $('.hiding').css('opacity', 0);
    //         $('.animated').appear(function() {
    //             var element = $(this);
    //             var animation = element.data('animation');
    //             var animationDelay = element.data('delay');
    //             if (!animation) {
    //                 animation = 'fadeIn';
    //             }
    //             if(animationDelay) {
    //                 setTimeout(function(){
    //                     element.removeClass('hidden');
    //                     element.addClass( animation + " visible" );
    //                 }, animationDelay);
    //             } else {
    //                 element.removeClass('hidden');
    //                 element.addClass( animation + " visible" );
    //             }
    //
    //         }, {accY: -150});
    //     }
    // }

    /* ==== 4) Carousels ==== */
    //intro text slider
    // $('#carousel_fade_intro').carousel({
    //     interval: 2500,
    //     pause: "false"
    // });
    //
    // //works sliders
    // $('#carousel-1, #carousel-2 #carousel-3').carousel({
    //     interval: false
    // });

    /* ==== 5) Make intro section height of viewport / Min height is set to 445px in style.css ==== */
    // $(function() {
    //     $('#intro .item').css({'height':($(window).height())+'px'});
    //     $(window).resize(function() {
    //         $('#intro .item').css({'height':($(window).height())+'px'});
    //     });
    // });

    // function showAllHiddenElements() {
    //     $('.animated').each(function() {
    //         var element = $(this);
    //         var animation = element.data('animation');
    //         if (!animation) {
    //             animation = 'fadeIn';
    //         }
    //         element.removeClass('hidden');
    //         element.addClass( animation + " visible" );
    //     });
    // }
    // showAllHiddenElements();

    // if the window resizes, then ignore the animation logic and show all the elements
    // var rtime;
    // var timeout = false;
    // var delta = 200;
    // $(window).resize(function() {
    //     rtime = new Date();
    //     if (timeout === false) {
    //         timeout = true;
    //         setTimeout(resizeDone, delta);
    //     }
    // });
    //
    // function resizeDone() {
    //     if (new Date() - rtime < delta) {
    //         setTimeout(resizeDone, delta);
    //     } else {
    //         timeout = false;
    //         showAllHiddenElements();
    //     }
    // }

    // set off-canvas menu handling
    (function mainScript() {
        // get handles for offCanvas elements
        const offcanvasWrapper = document.querySelector('#offcanvasRight');
        const offcanvasHeader = document.querySelector('.offcanvas-header');
        const myOffcanvas = document.getElementById('offcanvasRight');

        // reset offcanvas menu
        // don't add things that is not a part of resetting offcanvas to resetDropdown() function
        function resetDropdown() {
            // console.log('resetDropdown()');
            // show the first level dropdown items
            // $('.navbar .dropdown-container').removeClass('submenu-hide');

            offcanvasWrapper.classList.remove('offcanvas');
            offcanvasWrapper.classList.remove('offcanvas-end');
            offcanvasWrapper.classList.add('d-none');
            offcanvasHeader.classList.add('d-none');

            $('.offcanvas-body-placeholder').removeClass('offcanvas-body');

            // reset any hidden menu items when canvas is closed
            $('.navbar .menu-item').removeClass('d-none slideOutLeft');
            $('.navbar .dropdown-container').removeClass('d-none submenu-appear submenu-hide');

            // reset any expanded items
            $('.navbar .dropdown.menu-item-has-children .dropdown-toggle').each(function (i, el) {
                // console.log(el);
                const $this = $(el);
                const parent = $this.closest('.menu-item-has-children');
                $this.attr('area-expanded', 'false');
                $this.next('.dropdown-container').removeClass('d-none');
                parent.removeClass('slideInLeft slideOutLeft');
            });
        }

        // handle when the offcanvas menu is opened
        myOffcanvas.addEventListener('show.bs.offcanvas', function () {
            // console.log('show.bs.offcanvas');
            // reset default Bootstrap right padding on modals
            document.querySelector('body').classList.add('pe-0');

            // add the offcanvas selectors to the body
            $('.offcanvas-body-placeholder').addClass('offcanvas-body');
            offcanvasWrapper.classList.add('offcanvas');
            offcanvasWrapper.classList.add('offcanvas-end');
            myOffcanvas.classList.remove('d-none');
            offcanvasHeader.classList.remove('d-none');

            $('.navbar .dropdown-container').addClass('d-none');
        });

        // handle when the offcanvas menu is closed
        myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
            // console.log('hidden.bs.offcanvas');
            resetDropdown();
        });

        // set sub-menu navigation
        $('.navbar .dropdown.menu-item-has-children .dropdown-toggle').on('click', function(e) {
            e.preventDefault();
            let $this = $(this);

            // set the expanded state for later use
            if ($this.attr('area-expanded') === 'true') {
                $this.attr('area-expanded', 'false');
            } else {
                $this.attr('area-expanded', 'true');
            }
            let isExpanded = $this.attr('area-expanded') === 'true';
            let parent = $(this).closest('.menu-item-has-children');

            // toggle items based on parent's expanded state
            if (isExpanded) {
                $this.next('.dropdown-container').removeClass('d-none').addClass('submenu-appear').removeClass('submenu-hide');
                parent.siblings().addClass('slideOutLeft').removeClass('slideInLeft');
            } else {
                let $dropdownContainer = $this.next('.dropdown-container');
                $dropdownContainer.addClass('submenu-hide').removeClass('submenu-appear');
                // hide the previous elements after a delay, so there's enough time for the animation to complete
                setTimeout(function () {
                    $dropdownContainer.addClass('d-none');
                }, 200);
                parent.siblings().addClass('slideInLeft').removeClass('slideOutLeft');
            }
        });

    })();

    /*
     |-----------------------------------------------------------
     | Owl Carousel Start
     |-----------------------------------------------------------
     */
    if ($().owlCarousel) {
        $('.owl-portfolio').owlCarousel({
            center: true,
            items: 2,
            loop: true,
            // nav: true,
            autoplay: true,
            // dots: true,
            autoWidth: true,
            margin: 0,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                700: {
                    items: 2,
                    nav: false
                },
                1000: {
                    items: 3,
                },
                1600: {
                    items: 3,
                }
            }
        });
    }
});

// redirect after CF7 Submit Event
// https://contactform7.com/dom-events/
document.addEventListener( 'wpcf7mailsent', function( event ) {
    window.location.href = '/thank-you-enquiry/';
}, false );
